import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../../forms/inputs/button';
import SSO from '../../utilities/sso';
import { usePools } from '../DatabaseContext';
import History from '../Components/History';

export default function DashboardPage ({ i18n }) {
    const history = useHistory();
    const { clearPool } = usePools();

    useEffect(() => {
        clearPool()
    }, [])

    return <div>
        <div className="sm:p-10 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${i18n.splash.image.url})`}}>
            <div className="bg-white sm:p-10 sm:max-w-md">
                <div>
                    <svg width="44" height="48" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path fill="#404148" d="M0 47.876h29.648V6.649H0z"/><path fill="#FFF" d="M3.333 20.009h22.882V9.874H3.333zM3.333 26.822h4.353v-4.353H3.333zM9.412 26.822h4.353v-4.353H9.412zM15.491 26.822h4.353v-4.353h-4.353zM3.333 32.738h4.353v-4.353H3.333zM9.412 32.738h4.353v-4.353H9.412zM15.491 32.738h4.353v-4.353h-4.353zM3.333 38.654h4.353v-4.352H3.333zM9.412 38.654h4.353v-4.352H9.412zM15.491 38.654h4.353v-4.352h-4.353zM3.333 44.57h4.353v-4.352H3.333zM9.412 44.57h4.353v-4.352H9.412zM15.491 44.57h4.353v-4.352h-4.353zM21.789 26.822h4.353v-4.353h-4.353zM21.789 32.738h4.353v-4.353h-4.353zM21.789 44.57h4.353V34.338h-4.353z"/><path fill="#FFF" d="M21.956 18.5h21.232V2.504H21.956z"/><g fill="#414248" fillOpacity=".6"><path d="M23.631 4.338V2.273c0-.14.15-.225.273-.161C29.652 5.079 35.4-1.25 41.146 1.908c.06.034.1.099.1.168v2.066c0 .14-.149.225-.274.16-5.747-2.967-11.494 3.36-17.24.205a.196.196 0 01-.1-.17M23.631 9.81V7.745c0-.14.15-.226.273-.162 5.748 2.967 11.495-3.36 17.242-.204.06.034.1.1.1.17v2.064c0 .14-.149.225-.274.161-5.747-2.967-11.494 3.36-17.24.204a.193.193 0 01-.1-.168M23.631 15.282v-2.064c0-.14.15-.226.273-.162 5.748 2.967 11.495-3.36 17.242-.204.06.034.1.1.1.168v2.066c0 .14-.149.225-.274.161-5.747-2.967-11.494 3.36-17.24.204a.195.195 0 01-.1-.169"/></g></g></svg>
                </div>

                <div className="mt-4">
                    <h2 className="text-lg font-bold">{ i18n.dashboard.heading.replace('{name}', SSO.getIdentity().name) }</h2>
                </div>

                <div className="prose mt-4 text-grey-500" dangerouslySetInnerHTML={{ __html: i18n.dashboard.bodyCopy }} />

                <div className="mt-6">
                    <Button onClick={ () => history.push('/new') }>{ i18n.dashboard.button }</Button>
                </div>
            </div>
        </div>
        <div className="mt-12">
            <History i18n={i18n} />
        </div>
    </div>
}
